<div class="advanced-settings">
  <div class="container">
    <div>
      <div class="back" (click)="goBack()">
        <i class="fa fa-caret-left back-btn"></i>
        Back
      </div>
      <ul class="left-menu">
        <li [class.active]="tab === 0" (click)="tab = 0">Verify</li>
      </ul>
    </div>
    <div class="content">
      @if(tab === 0) {
        <div class="content__title">Verify</div>
        <div class="content__box verify-content-shepherd">
          <label class="input">
            <input class="input__field" type="email" placeholder=" " [(ngModel)]="email" />
            <span class="input__label">Email</span>
          </label>
          <button *ngIf="!isEmailVerify" class="btn btn-secondary mb-2" (click)="handleOTPVerification(VerifyEmailOtp)"><i class="fa fa-envelope"></i> Verify Email</button>
          <br />
          <div (click)="getTelegramLinks()" class="btn-verified" [class.green]="profileInfo?.isTelegramVerified">
            <i class="fa-brands fa-telegram icon"></i>
            <div>
              <div class="name">Telegram</div>
              <div class="meta">{{ profileInfo?.isTelegramVerified ? "" : "Not" }} Verified</div>
            </div>
            <i
              class="fa fa-check-circle"
              [ngStyle]="{
                color: profileInfo?.isTelegramVerified ? 'green' : 'red'
              }"
            ></i>
          </div>
          <div class="btn-verified" [class.green]="profileInfo?.isVerified" (click)="profileInfo?.isVerified ? '' : (showVerificationTelegram = true)">
            <i class="fa-brands fa-whatsapp icon"></i>
            <div>
              <div class="name">WhatsApp</div>
              <div class="meta">{{ profileInfo?.isVerified ? "" : "Not" }} Verified</div>
            </div>
            <i
              class="fa fa-check-circle"
              [ngStyle]="{
                color: profileInfo?.isVerified ? 'green' : 'red'
              }"
            ></i>
          </div>
  
          <div class="verification" *ngIf="showVerificationTelegram" [ngClass]="{ active: showVerificationTelegram }">
            <span (click)="showVerificationTelegram = false; isReset = false">
              <i class="fa-solid fa-times" style="color: black !important"></i>
            </span>
            <div>
              <div style="display: flex; justify-content: center; align-items: center">
                <mat-label>Enter OTP</mat-label>
                <mat-form-field style="width: 100%; display: flex; align-items: center; gap: 10px">
                  <input matInput formControlName="otp" maxlength="6" style="text-align: center" class="form-control" (change)="onChangeOtp($event)" required />
                  <button mat-raised-button color="primary" (click)="sendOtp()" [disabled]="isLoading" style="margin-bottom: 10px" class="btn btn-purple">OTP</button>
                </mat-form-field>
              </div>
  
              <mat-form-field style="width: 100%; display: flex; flex-direction: column">
                <mat-label class="mb-2 mt-2">Enter 4 Digit Passcode</mat-label>
                <input matInput formControlName="otp" maxlength="4" style="text-align: center" class="form-control mb-2" (change)="onChangePasscode($event)" required />
              </mat-form-field>
              <div style="color: red">{{ otpError }}</div>
              <button (click)="verifyOtp()" [disabled]="isLoading" class="btn btn-purple mt-2">Verify</button>
            </div>
          </div>
        </div>
        <ng-template #VerifyEmailOtp let-modal>
          <div class="modal-body">
            <div class="add_cattt d-flex justify-content-between">
              <h2>Verify Email OTP</h2>
              <img loading="lazy" src="../../../assets/images/close-icon.svg" alt="img" (click)="modal.dismiss('Cross click')" />
            </div>
            <div class="referral-link">
              <section class="m-4">
                <div class="form-group">
                  <input placeholder="Enter OTP" type="text" name="selectedMemberPassword" pattern="\d*" maxlength="6" autofocus class="otp-input w-100" [(ngModel)]="selectedOTP" required />
                </div>
                <p class="error-message p-0" *ngIf="invalidOtp">{{ invalidOtp }}</p>
              </section>
              <div class="mt-4">
                <div class="cart_btn">
                  <button class="my-button-3 px-2" (click)="verifyEmailOtp()">Verify <i class="fa fa-check-circle" aria-hidden="true"></i></button>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      }
    </div>
  </div>
</div>
